import React, { useEffect } from 'react'
import { Nav } from 'react-bootstrap'
import PropTypes from 'prop-types'
import { useRouter } from 'next/router'

import styles from './style.module.scss'
import Link from 'next/link'

const CommonNav = (props) => {
  const router = useRouter()
  useEffect(() => {
    const active = typeof window !== 'undefined' && document.getElementById(router.asPath)
    if (active) active.scrollIntoView({ block: 'end', inline: 'center' })
  }, [])
  return (
    <>
      <Nav
        variant="pills"
        className={`${styles.commonNav} ${props.isEqualWidth && 'equal-width-nav'} ${props.isSticky ? styles.stickyNav : ''} ${
          props.themeLight ? styles.themeLightNav : ''
        } ${props.className} text-uppercase scroll-list flex-nowrap text-nowrap`}
      >
        {props?.items?.map(({ navItem, url, active, icon }) => {
          return (
            <Nav.Item key={url} className={`${styles.item} ${icon ? `${styles.icon}` : ''}`}>
              <Link
                id={url}
                className={`${active ? styles.active : ''} ${icon ? 'd-flex align-items-center' : ''} nav-link`}
                target={navItem === 'Standings' && props.isMatch ? '_blank' : '_self'}
                href={{
                  pathname: url,
                  query: props.queryParams ? { q: router?.query?.q } : null
                }}
                prefetch={false}
              >
                {icon && <span className="me-1 text-primary">{icon}</span>}
                {typeof navItem === 'string' ? navItem?.replaceAll('-', ' ') : navItem}
              </Link>
            </Nav.Item>
          )
        })}
        <Nav.Item className={`${styles.item}`}>{props.children}</Nav.Item>
      </Nav>
    </>
  )
}

CommonNav.propTypes = {
  items: PropTypes.array,
  isEqualWidth: PropTypes.bool,
  themeLight: PropTypes.bool,
  queryParams: PropTypes.bool,
  isMatch: PropTypes.bool,
  className: PropTypes.string,
  isSticky: PropTypes.bool,
  children: PropTypes.any
}

export default CommonNav
